<template>
  <v-row>
    <v-col
        v-for="index in 3"
        :key="index"
        cols="12"
        md="4"
        lg="3"
    >
      <v-row :no-gutters="true">
        <v-col>
          <v-skeleton-loader
              class="car-card-title-skeleton-loader"
              type="heading"
          />
        </v-col>
      </v-row>
      <v-row
          v-for="optionIndex in optionIndexes[index - 1]"
          :key="optionIndex"
          :no-gutters="true"
      >
        <v-col>
          <v-skeleton-loader
              class="car-card-title-skeleton-loader"
              type="text"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>

export default{
  name: "CarSpecificationDetailsSkeleton",
  data() {
    return {
      optionIndexes: [9, 4, 6]
    }
  }
}
</script>

<style scoped>
::v-deep .car-card-title-skeleton-loader > * {
  margin-inline-start: 0;
}
</style>